<template>
  <div class="footer-social">
    <ul class="list-reset">
      <li>
        <a href="https://twitter.com/SRVControl" target="_blank">
          <font-awesome-icon class="fa-lg" :icon="['fab', 'twitter']" />
        </a>
      </li>
      <li>
        <a href="https://discord.gg/7d2s79t" target="_blank">
          <font-awesome-icon class="fa-lg" :icon="['fab', 'discord']" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CFooterSocial'
};
</script>
